<app-main-nav></app-main-nav>
<div class="login-logo">
  <img src="assets/img/logo.svg" alt="ViewLabs" class="login-logo__img">
</div>
<div class="login-form form" [formGroup]="form">
  <h1 class="title mt-05 mb-0 text-center">Login</h1>
  <div class="inputs-wrap">
    <div class="form-group">
      <input formControlName="name"
             class="form-group__input form-group__input--inverse"
             placeholder="Email"
             type="text">
      <span class="form-group__errors" *ngIf="fcName.touched && fcName.errors && fcName.errors.required">Email is required!</span>
    </div>

    <div class="form-group form-group--icon-right">
      <input formControlName="password"
             class="form-group__input form-group__input--inverse"
             placeholder="Password"
             [type]="showPassword ? 'text' : 'password'">
      <app-pw-eye *ngIf="fcPassword.value?.length"
                  [isVisible]="showPassword"
                  class="form-group__right-icon color-accent"
                  (click)="togglePasswordVisibility()"></app-pw-eye>
      <span class="form-group__errors" *ngIf="fcPassword.touched && fcPassword.errors && fcPassword.errors.required">Password is required!</span>
    </div>
  </div>

  <div class="text-center mb-2">
    <a mat-flat-button class="color-gray_3" (click)="resetPassword()">Reset password</a>
  </div>

  <button mat-flat-button class="btn btn--l btn--primary btn--block" (click)="onSubmit()" [disabled]="form.invalid">Submit</button>
</div>

